import React, { useMemo } from 'react';
import { Box, HStack, Stack, VStack, ChevronDownIcon, ChevronUpIcon, useMediaQuery, useDisclose, Pressable } from 'native-base';
import { isEmpty } from 'lodash';
import { BorderedCard } from 'fmc-digital-common';
import { LoanSummaryData } from '../../molecules';
import NewLoanInProgressHeader from '../NewLoanInProgressHeader';
import Functions from '../../../../utils/Functions';
const LoanOverviewComponent = props => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 430
  });
  const {
    isOpen,
    onToggle
  } = useDisclose(false);
  const {
    loanOverviewData: {
      terms,
      lockExpirationDate,
      loanScheduledClosingDate,
      scheduledFirstPaymentDate,
      loanEstimatedClosingDate
    },
    loanStatus
  } = props;
  const {
    baseLoanAmount,
    noteRatePercent,
    mortgageType,
    APR
  } = useMemo(() => {
    let result = {
      baseLoanAmount: 0,
      noteRatePercent: 0,
      mortgageType: '',
      APR: 0
    };
    if (Array.isArray(terms) && terms.length) {
      const [first] = terms;
      if (first) {
        result = {
          baseLoanAmount: first?.baseLoanAmount,
          noteRatePercent: first?.noteRatePercent,
          APR: first?.extensions?.other?.APR,
          mortgageType: first?.mortgageType
        };
      }
    }
    return result;
  }, [terms]);
  const handleIsOpen = () => {
    if (isSmallScreen) onToggle();
  };
  const loanSummary = [{
    label: 'Product Type:',
    value: mortgageType
  }, {
    label: 'Loan Amount:',
    value: Functions.toUSD(baseLoanAmount)
  }];
  const loanDetail = [{
    label: 'Product Type:',
    value: mortgageType
  }, {
    label: 'Rate:',
    value: `${Number(noteRatePercent).toFixed(2)}% ${APR || APR === 0 ? `(${Number(APR).toFixed(2)}% APR)` : null}`
  }, {
    label: 'Loan Amount:',
    value: Functions.toUSD(baseLoanAmount)
  }, {
    label: 'Rate Lock Expiration:',
    value: Functions.useSafeParseDateFormat(lockExpirationDate)
  }, {
    label: isEmpty(loanScheduledClosingDate) ? 'Anticipated Closing:' : 'Scheduled Closing:',
    value: Functions.useSafeParseDateFormat(isEmpty(loanScheduledClosingDate) ? loanEstimatedClosingDate : loanScheduledClosingDate)
  }, {
    label: 'First Payment Due:',
    value: Functions.useSafeParseDateFormat(scheduledFirstPaymentDate)
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isSmallScreen ? /*#__PURE__*/React.createElement(BorderedCard, {
    border: "border.primary",
    borderWidth: "1",
    bgColor: "white.500",
    px: "4",
    py: loanStatus < 11 ? '4' : '2',
    testID: "loan-summary-root",
    width: "auto",
    marginBottom: 8
  }, /*#__PURE__*/React.createElement(VStack, null, !terms || !Array.isArray(terms) || terms.length === 0 ? null : /*#__PURE__*/React.createElement(LoanSummaryData, {
    data: loanStatus < 11 ? loanSummary : loanDetail,
    screenFlag: true
  }))) : /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => handleIsOpen(),
    accessibilityLabel: isOpen ? 'close' : 'open',
    testID: isOpen ? 'expand-status' : 'collapse-status'
  }, /*#__PURE__*/React.createElement(BorderedCard, {
    bgColor: "white.500",
    border: "primary.400",
    p: "4",
    pb: "2"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Summary"
  })), /*#__PURE__*/React.createElement(Box, null, isOpen ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
    size: "lg"
  }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: "lg"
  })))), !isOpen ? null : /*#__PURE__*/React.createElement(LoanSummaryData, {
    data: loanStatus < 11 ? loanSummary : loanDetail,
    screenFlag: false
  })))));
};
export default /*#__PURE__*/React.memo(LoanOverviewComponent);
//# sourceMappingURL=index.js.map